export default "__VITE_ASSET__BgceNPra__"